export default "/images/bc09d2d6bbe109efd9c05d4224fe7edb.avif";